import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useBreadcrumb } from "@/contexts/BreadcrumbContext";
import { SettingsTabs } from "@/routes/settings/SettingsTabs";
import { SettingsBrevo } from "./SettingsBrevo";
import {
  getCurrentSettingsTab,
  getSettingsTabs,
  SETTINGS_TAB_PATHS,
} from "./settingsTabsShared";

export function SettingsBrevoRoute() {
  const { setBreadcrumbs, clearBreadcrumbs } = useBreadcrumb();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setBreadcrumbs([
      { label: "Settings", path: "/settings" },
      { label: "Integrations", path: "/settings/integrations" },
      { label: "Brevo", path: "/settings/integrations/brevo" },
    ]);

    return () => {
      clearBreadcrumbs();
    };
  }, []);

  const handleTabChange = (value: string) => {
    const path = SETTINGS_TAB_PATHS[value];
    if (path) navigate(path);
  };

  return (
    <SettingsTabs
      value={getCurrentSettingsTab(location.pathname)}
      tabs={getSettingsTabs({ integrationsContent: <SettingsBrevo /> })}
      onValueChange={handleTabChange}
    />
  );
}
